import { fromJS, toJS } from "immutable";
import { 
  singleExchangesType, 
  resetDataType, 
  startDateMobileType, 
  endDateMobileType, 
  selectGAtabType,
  setFilteredType,
  gaRecurringDataType,
  gaAgreementDataType,
  cancelGrantsType,
  lazyLoadDataLoaderType,
  lazyLoadDataSuccessGaType,
  lazyLoadRecurringDataSuccessGaType,
  lazyLoadRecurringDataLoaderType,
  cancelGrantsDataFailureType,
  singleGrantsSuccessGaType,
  updateSingleGrantsType,
  showGaLoaderType,
  allSingleGrantsInitiateType
 } from "./actionTypes";
const initialState = fromJS({
  singleExchanges: {
    isLoading: true,
    isLoadingGrants: false,
    data: "",
    dataAvail:false,
    lazy: false,
    error: "",
    initialPendingData: {},
    avail:false,
    showGaLoader: false,
    initiateAllSingleGrantsFetch: false
  },
  grantAgreement: {
    isLoading: true,
    data: [],
    error: ""
  },
  recurringExchanges: {
    isLoading: true,
    data: "",
    error: "",
    isLoadingRecurring: false,
    lazy: false,
  },
  currentTab: {
    data: "single"
  },
  dates: {
    start: "",
    end: ""
  },
  cancel: 0,
  cancelResponse: "",
  tab: "1",
  filtered: [],
  scrollTop:""
});

const grantsActivity = (state = initialState, action) => {
  switch (action.type) {
    case singleExchangesType:
      return state
        .setIn(["singleExchanges", "data"], action.payload)
        .setIn(["singleExchanges", "avail"], action.payload.dataAvailableForNextRequest);
    case gaRecurringDataType:
      return state
        .setIn(["recurringExchanges", "data"], action.payload)
    case gaAgreementDataType:
      return state
        .setIn(["grantAgreement", "data"], action.payload)
    case startDateMobileType:
      return state.setIn(["dates", "start"], action.payload);
    case endDateMobileType:
      return state.setIn(["dates", "end"], action.payload);
    case cancelGrantsType:
      return state
        .setIn(["cancel"], action.count)
        .setIn(["cancelResponse"], action.payload)
    case cancelGrantsDataFailureType:
      return state
        .setIn(["cancelResponse"], action.payload)
    case "":
      return state
        .setIn(["recurringExchanges", "isLoading"], true)
        .setIn(["singleExchanges", "isLoading"], true)
        .setIn(["grantAgreement", "isLoading"], true);
    case lazyLoadDataLoaderType:
      return state.setIn(["singleExchanges", "lazy"], false).setIn(["tab"], "1")
      .setIn(["singleExchanges", "isLoadingGrants"], true);
      
    case resetDataType:
      return state
        .setIn(["cancel"], [])
        .setIn(["recurringExchanges", "data"], [])
        .setIn(["grantAgreement", "data"], [])
        .setIn(["singleExchanges", "lazy"], false);
    case lazyLoadDataSuccessGaType:
      return state
        .setIn(["singleExchanges", "avail"], action.payload.dataAvailableForNextRequest)
       // .updateIn(["singleExchanges", "data","singleGrants"],()=> {return action.payload.singleGrants})
        .setIn(
          ["singleExchanges", "data", "singleGrants"],
          [
            ...state.getIn(["singleExchanges", "data", "singleGrants"]),
            ...action.payload.singleGrants,
          ]
        )
        .setIn(["singleExchanges", "lazy"], true)
        .setIn(["singleExchanges", "isLoadingGrants"], false);

        //RECURRING GRANTS LAZY
        case lazyLoadRecurringDataLoaderType:
        return state
        .setIn(["recurringExchanges", "lazy"], false).setIn(["tab"], "2")
        .setIn(["recurringExchanges", "isLoadingRecurring"], true);
        //RECURRING GRANTS LAZY
        case lazyLoadRecurringDataSuccessGaType:
          return state
           
          .setIn(["recurringExchanges", "data"], action.payload)
          
            .setIn(
              ["recurringExchanges", "data", "recurringGrant"],
              [
                ...state.getIn(["recurringExchanges", "data", "recurringGrant"]),
                ...action.payload.recurringGrant,
              ]
            )
            .setIn(["recurringExchanges", "isLoadingRecurring"], false)
            .setIn(["recurringExchanges", "lazy"], true)
    case showGaLoaderType:
      return state
        .setIn(["singleExchanges", "showGaLoader"], true)
    case allSingleGrantsInitiateType: 
      return state
      .setIn(["singleExchanges", "initiateAllSingleGrantsFetch"], true)
    case singleGrantsSuccessGaType:
      return state
        .setIn(["singleExchanges", "showGaLoader"], false)
        .setIn(["singleExchanges", "data", "allSingleGrants"], action.payload.singleGrants)
    case updateSingleGrantsType:
      return state
        .setIn(["singleExchanges", "avail"], true)
        .setIn(["singleExchanges", "showGaLoader"], false)
        .updateIn(["singleExchanges", "data", "singleGrants"],()=> { return action.payload })
    case selectGAtabType:
      return state.setIn(["tab"], action.payload);
    case setFilteredType:
      return state.setIn(["filtered"], action.payload);
    default:
      return state;
  }
};

export default grantsActivity;
